export function getView(connections, automationId, is_created) {
  if (automationId) return false

  if (
    !Array.isArray(connections) ||
    connections.filter(
      connection =>
        connection.status === 'active' &&
        connection.current_location_resource?.status === 'enabled'
    ).length === 0
  )
    return false

  return !is_created
}
